export default {
  title: 'Solicită ștergerea datelor pentru {{name}}',
  description:
    'Aceasta creează o cerere de ștergere a datelor GDPR. Un administrator trebuie să o aprobe înainte ca datele clientului să fie șterse definitiv.',
  form: {
    note: {
      label: 'Notă',
      placeholder: 'Adaugă context pentru această cerere (opțional)',
    },
  },
  buttons: {
    confirm: 'Solicită ștergerea',
  },
  toasts: {
    success: 'Cerere de ștergere a datelor creată',
    error: 'Crearea cererii de ștergere a datelor a eșuat',
  },
};
